module.exports = __webpack_public_path__ + "img/storehouse.51ad0153.webp";